export enum AppEnvironment {
  Admin = 'admin',
  Customer = 'customer',
  Cosmos = 'cosmos'
}
